import { render, staticRenderFns } from "./MoreFieldsIconwTextidget.vue?vue&type=template&id=a51b271a&"
import script from "./MoreFieldsIconwTextidget.vue?vue&type=script&lang=js&"
export * from "./MoreFieldsIconwTextidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports